import { createAsyncThunk } from '@reduxjs/toolkit'

import { IEventData } from 'meta/pages/v4/event'
import { EventController } from 'controller/event'

type Returned = IEventData

type Props = {
  idOrCodeUrl: string
}

export const getData = createAsyncThunk<Returned, Props>('pages/event/data', async (props) => {
  const { idOrCodeUrl } = props

  return EventController.getData({ idOrCodeUrl })
})
